import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=3f042765"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f042765')) {
      api.createRecord('3f042765', component.options)
    } else {
      api.reload('3f042765', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=3f042765", function () {
      api.rerender('3f042765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChangePassword/ChangePassword.vue"
export default component.exports